import React from 'react';
import { GuestGuard, PartnerGuard } from '../guards/RolesGuard';
import Login from '../features/auth/login';
import Register from '../features/auth/register';
// import ResetPassword from '../features/auth/reset-password';
import Layout from '../container/Layout';
import Homepage from '../features/dashboard/homepage';
import Settings from '../features/dashboard/settings';
import EmployeeUpdatedNewsList from '../features/dashboard/employee-updated-news/EmployeeUpdatedNewsList';
import BrandingConfigCard from '../features/dashboard/ui-branding/BrandingConfigEditor';
import Queries from '../features/dashboard/queries/Queries';
// import WelcomePage from '../features/auth/welcome';

export interface RouteDefinition {
    path: string;
    element: JSX.Element;
    guard?: () => boolean;
    index?: string;
    key?: string;
    childrens?: RouteDefinition[];
}

export const routes: RouteDefinition[] = [
    // {
    //     path: '/',
    //     element: <WelcomePage />,
    //     key: 'guest',
    //     guard: GuestGuard,
    // },
    {
        path: '/login',
        element: <Login />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/apply',
        element: <Register />,
        key: 'guest',
        guard: GuestGuard,
    },
    // {
    //     path: '/reset-password',
    //     element: <ResetPassword />,
    //     key: 'guest',
    //     guard: GuestGuard,
    // },

    {
        path: '/',
        element: <Layout />,
        index: '/insights',
        key: 'broker',
        guard: PartnerGuard,
        childrens: [
            {
                path: 'insights',
                element: <Homepage />,
            },
            {
                path: 'employee-updated-news',
                element: <EmployeeUpdatedNewsList />,
            },
			{
                path: 'ui-branding',
                element: (
                    <BrandingConfigCard type={'SOFIA'} hotelUsername={'nynn'} />
                ),
            },
			{
                path: '/settings',
                element: <Settings />,
            },
			{
				path: '/queries',
				element: <Queries />
			}
        ],
    },
];
